import React, { useState } from "react";
import "../../assets/css/style.css";
import "../../assets/css/login.css";

import EditProfile from "../../components/profile/editProfile";
import NavBar from "../../components/general/NavBarApp";
import EditCompanyProfile from "../../components/profile/editCompanyProfile";

const EditProfilePage = () => {
  return (
    <div className="main">
      <NavBar />
      <EditProfile />
    </div>
  );
};

export default EditProfilePage;
